import React, { useState, useEffect } from 'react';
import { Collapse, Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment'; // To handle date formatting
import * as XLSX from 'xlsx'; // Import xlsx for Excel file generation
import { BsDownload } from 'react-icons/bs';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Table } from 'react-bootstrap';
import { Spinner } from 'react-bootstrap';  // for loading indicator (Bootstrap style)  
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DOMPurify from "dompurify";

const Completed = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [orders, setOrders] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [openOrder, setOpenOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null); // To store the order for which "Add num" was clicked
  const [trackingLabel, setTrackingLabel] = useState(''); // To store the tracking label input
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState('');
  const [ordernotes, setOrdernotes] = useState("");
  const [search, setSearch] = useState('')
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [sortByDueDate, setSortByDueDate] = useState(false); // Add sorting toggle
  const [updatedOrder, setUpdatedOrder] =useState(null);
  const [field, setField] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [showSizeModal, setShowSizeModal] = useState(false); // State for Size Modal
  const [orderSizes, setOrderSizes] = useState({});
  const [orderId, setOrderId] = useState(null);
 
  const [address, setAddress] = useState('')
  const [garments, setGarments] = useState([]);
    const [showGarmentModal, setShowGarmentModal] = useState(false);
    const sentinelRef = React.useRef(null);

  
    const [selectedGarments, setSelectedGarments] = useState([]);
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0]; // Formats as YYYY-MM-DD
  };

  const [fromDate, setFromDate] = useState(getTodayDate());
  const [toDate, setToDate] = useState(getTodayDate()); // instead of ''

const handleDateChange = (e) => {
  const { name, value } = e.target;
  if (name === 'fromDate') setFromDate(value);
  if (name === 'toDate') setToDate(value);
};

const fetchGarments = async (poNumber) => {
  console.log(poNumber)
  try {
      const response = await axios.get(`${API_URL}/garments?po=${poNumber}`);

      setGarments(prevGarments => [...prevGarments, ...response.data]);
      console.log(garments)
  } catch (error) {
      console.error('Error fetching garments:', error);
  }
}
const handleAddGarmentsClick = (order) => {
  setOrderId(order.id);
  const garmentPOs = order.garmentPO.split(',');

  garmentPOs.forEach(garmentPO => {
      console.log(garmentPO)
      fetchGarments(garmentPO.trim()); // Use trim() to remove any extra whitespace
  });

  setShowGarmentModal(true);
};



const handleSelectGarment = (garmentId,po, style, description, color, size,available_qty, quantity) => {
    console.log(quantity)
    setSelectedGarments((prev) => {
        // Check if the garment already exists in the selection
        const existingGarment = prev.find((g) => g.garmentId === garmentId);
        if (existingGarment) {
            // Update quantity if the garment is already selected

            return prev.map((g) =>
                g.garmentId === garmentId ? { ...g, quantity } : g
            );
        }

        // Add new garment to selection
        return [
            ...prev,
            { garmentId,po, style, description, color, size, quantity },
        ];
        
    });
    
};

const handleAssignGarments = async () => {
  console.log(selectedGarments)
  if (selectedGarments.length === 0) {
      alert('Please select at least one garment to assign.');
      return;
  }

  try {
      const response = await axios.post(`${API_URL}/assignGarments`, {
          orderId,
          garments: selectedGarments,
      });
      console.log(response)
      if (response.status === 200) {
          alert('Garments assigned successfully.');
          setShowGarmentModal(false);

          // Clear the selection and refresh the orders list
          setSelectedGarments([]);
          
      } else if (response.status === 400){
          alert(response.message);
      }
      
  } catch (error) {
      console.error('Error assigning garments:', error);
      alert('An error occurred while assigning garments.');
  }
};

const handleDeleteGarment = async (garment) => {
    console.log(garment.order_id)
    if (window.confirm('Are you sure you want to delete this garment?')) {
        try {
            // Send request to backend to update shipping status and delete the garment
            const response = await fetch(`${API_URL}/delete-garment`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({garmentId: garment.garment_id, garmentAssignId: garment.id, quantity: garment.quantity }),
            });

            if (response.ok) {
                alert('Garment deleted successfully.');
                // Remove the deleted garment from the list
                setGarmentDetails((prevDetails) => prevDetails.filter((g) => g.id !== garment.id));
            } else {
                alert('Failed to delete the garment.');
            }
        } catch (error) {
            console.error('Error deleting garment:', error);
            alert('An error occurred while deleting the garment.');
        }
    }
};

  const [sizeData, setSizeData] = useState({
    category: 'Adult', // Default category
    description: '',
    color: '',
    xs: 0,
    s: 0,
    m: 0,
    l: 0,
    xl: 0,
    xxl: 0,
    xxxl:0,
    xxxxl:0,
    xxxxxl:0,
  });

  const handleSizeInputChange = (event) => {
    const { name, value } = event.target;
    setSizeData((prevData) => ({
      ...prevData,
      [name]: name === 'xs' || name === 's' || name === 'm' || name === 'l' || name === 'xl' || name === 'xxl' || name === 'xxxl' || name === 'xxxxl' || name === 'xxxxxl'
        ? parseInt(value) || 0  // Convert to number or default to 0 if empty
        : value
    }));
    console.log(sizeData);
  };

  const handleSizeModalShow = (orderNumber,shippingAddress) => {
    setSelectedOrder(orderNumber); // Set the selected order number
    setAddress(shippingAddress)
    setShowSizeModal(true);
  };


  
function cleanFileName(url) {
  // Decode URI components to handle encoded characters like %20 for space
  let decodedUrl = decodeURIComponent(url);
  
  // Extract the filename from the URL if necessary
  let fileName = decodedUrl.split('/').pop(); // Gets the last part after the last slash
  
  // Optional: Remove any unwanted parts from the filename, such as timestamps or identifiers
  // For example, if filenames contain a pattern like '1730410751349-', you might want to remove it:
  fileName = fileName.replace(/^\d+-/, ''); // Removes leading digits followed by a dash
  
  // More cleaning can be applied here depending on the specific filename patterns you have
  
  return fileName;
}
  
  const handleSizeFormSubmit = async () => {
    try {
      // Fetch order ID using the selected order and address
      const response = await fetch(
        `${API_URL}/getOrderId?orderNumber=${selectedOrder}&shippingAddress=${address}`
      );
      
      if (!response.ok) {
        throw new Error('Order not found');
      }
  
      const data = await response.json();  // Correctly parse the response JSON
      console.log(data + "kjhgfyhj");  // Log the received order ID or response
  
      if (!data || !data.order_id) {  // Check if order_id exists in the response
        alert('Order not found');
        return;
      }
  
      // Ensure sizeData contains valid numbers for sizes
      const formattedSizeData = {
        ...sizeData,
        xs: parseInt(sizeData.xs) || 0,
        s: parseInt(sizeData.s) || 0,
        m: parseInt(sizeData.m) || 0,
        l: parseInt(sizeData.l) || 0,
        xl: parseInt(sizeData.xl) || 0,
        xxl: parseInt(sizeData.xxl) || 0,
        xxxl: parseInt(sizeData.xxxl) || 0,
        xxxxl: parseInt(sizeData.xxxxl) || 0,
        xxxxxl: parseInt(sizeData.xxxxxl) || 0,
      };
  
      // POST the size data to the server using the retrieved order_id
      const sizeResponse = await axios.post(
        `${API_URL}/orders/${data.order_id}/sizes`,
        formattedSizeData
      );
  
      console.log('Size data added:', sizeResponse.data);
      setShowSizeModal(false); // Close the modal after successful submission
    } catch (error) {
      console.error('Error adding size data:', error);
      alert(error.message); // Display error to the user
    }
  };
  
  

  

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    // Check if user is an admin
    if (user && (user.email.toLowerCase() === "riz@tssprinting.com" || user.email.toLowerCase() === "mussa@tssprinting.com" || user.email.toLowerCase() === "karachi@tssprinting.com")) {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  }, []);


  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };
  

  const fetchOrders = async () => {
    if (loading) return;
    setLoading(true);
  
    try {
      const url = `${API_URL}/completedList?page=${page}&limit=20&search=${search}&fromDate=${fromDate}&toDate=${toDate}`;
      console.log("Fetching orders from:", url);
  
      const res = await fetch(url);
  
      if (!res.ok) {
        throw new Error(`Server returned ${res.status} - ${res.statusText}`);
      }
  
      const data = await res.json();
  
      if (!Array.isArray(data)) {
        console.error("Expected an array of orders but got:", data);
        setHasMore(false);
        return;
      }
  
      setOrders(prev => {
      const byId = new Map((prev || []).map(o => [String(o.id ?? o.orderNumber), o]));
      (Array.isArray(data) ? data : []).forEach(o => {
        byId.set(String(o.id ?? o.orderNumber), o);
      });
      return Array.from(byId.values());
    });

    // adjust 20 if your page size changes
    setHasMore(Array.isArray(data) && data.length === 20);
  
    } catch (error) {
      console.error('Error fetching completed orders:', error.message);
    } finally {
      setLoading(false);
    }
  };
  
  
  useEffect(() => {
    fetchOrders();
  }, [page,search, fromDate, toDate]);
  useEffect(() => {
    // Reset list and pagination
    setOrders([]);
    setPage(1);
    setHasMore(true);
    // We will fetch new data after state updates (see next effect)
  }, [search, fromDate, toDate]);

 useEffect(() => {
  const el = sentinelRef.current;
  if (!el) return;

  const io = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting && hasMore && !loading) {
        setPage(p => p + 1);
      }
    },
    { rootMargin: '200px' } // prefetch a bit before bottom
  );

  io.observe(el);
  return () => io.disconnect();
}, [hasMore, loading]);



  useEffect(() => {
    const fetchOrderSizes = async () => {
      console.log(orderId)
      if (orderId) {
        try {
          const response = await axios.get(`${API_URL}/fetchorders/${orderId}/sizes`);
          setOrderSizes((prevSizes) => ({
            ...prevSizes,
            [orderId]: response.data, // Store sizes for this order
          }));
          console.log(orderSizes)
        } catch (error) {
          console.error('Error fetching sizes:', error);
        }
      }
    };

    if (openOrder) {
      fetchOrderSizes(); // Fetch sizes only when an order is opened
    }
  }, [openOrder]);

  const handleOrderClick = (orderNumber,order_Id) => {
    setOpenOrder(openOrder === orderNumber ? null : orderNumber);
    setOrderId(order_Id)

  };

  console.log(orderSizes);

  const getSelectClass = (status) => {
    switch (status) {
      case 'DONE':
        return 'select-done';
      case 'COMPLETED':
        return 'select-completed';
      
      default:
        return '';
    }
  };
  const updateOrderStatusInDatabase = async (e, id) => {
    const status = e.target.value;
    try {
      const response = await fetch(`${API_URL}/updateOrderStatus/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status }),
      });

      if (!response.ok) {
        throw new Error('Failed to update order status');
      }

      const updatedOrder = await response.json();
      console.log('Order status updated successfully:', updatedOrder);

      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.id === id ? { ...order, orderStatus: status } : order
        ).filter((order) => order.orderStatus !== 'SHIPPED')
      );
    } catch (error) {
      console.error('Error updating order status:', error);
    }
  };

  
  const handleUpdateOrder = async () => {
    if (!orderId || !field || updatedOrder === undefined || updatedOrder === null) {
      alert('Please provide all necessary details before updating the order.');
      return;
    }
  
    try {
      // Make the API call to update the selected order's specific field
      const response = await axios.put(`${API_URL}/updateOrder/${orderId}`, { [field]: updatedOrder });
  
      if (response.status === 200) {
        alert(response.data.message || 'Order updated successfully');
  
        // Update the local state with the new order data
        setOrders((prevOrders) =>
          prevOrders.map((order) => {
            if (order.id === orderId) {
              // Handle notes by appending the new note to the existing notes
              if (field === 'notes') {
                return { ...order, notes: `${order.notes ? order.notes + '\n' : ''}${updatedOrder}` };
              }
              // Handle other fields normally
              return { ...order, [field]: updatedOrder };
            }
            return order;
          })
        );

        setShowModal3(false);
      setOrderId('');
      setUpdatedOrder(''); 
  
        // Reset the modal state and clear inputs after successful update
        
      } else {
        alert('Failed to update the order. Please try again.');
      }
    } catch (error) {
      console.error('Error updating order:', error);
      alert('An error occurred while updating the order. Please try again.');
    }
  };


  // Function to show modal and set the order and field being edited
  const handleOrder = (id, field) => {
    setShowModal3(true);
    setOrderId(id);
    setField(field); // Track the field being updated
  };

  const deleteOrder = async (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this order?');
    if (confirmDelete) {
      try {
        const response = await axios.delete(`${API_URL}/deleteorder/${id}`);
        if (response.status === 200) {
          setOrders(orders.filter(order => order.id !== id));
          alert('Order deleted successfully.');
        }
      } catch (error) {
        console.error('Error deleting order:', error);
        alert('Failed to delete the order.');
      }
    }
  };

  const toggleSortByDueDate = () => {
    setSortByDueDate(!sortByDueDate);
    const sortedOrders = [...orders].sort((a, b) => {
      const dateA = new Date(a.dueDate);
      const dateB = new Date(b.dueDate);
      return sortByDueDate ? dateA - dateB : dateB - dateA;
    });
    setOrders(sortedOrders);
  };

 const downloadPDF = () => {
   const doc = new jsPDF('landscape');
   doc.text('Completed Orders', 14, 22);
 
   const normalizeOneLine = (s) =>
     (s ?? '')
       .toString()
       .replace(/(\r\n|\n|\r)/g, ' ')
       .replace(/\s+/g, ' ')
       .trim();
 
   const htmlToPlain = (html) => {
     if (!html) return 'No Garment details';
     const clean = DOMPurify.sanitize(html);
     const div = document.createElement('div');
     div.innerHTML = clean
       .replace(/<br\s*\/?>/gi, '\n')
       .replace(/<\/p>/gi, '\n');
     const text = div.textContent || div.innerText || '';
     return text.replace(/\n{3,}/g, '\n\n').trim();
   };
 
   const DETAILS_COL_WIDTH = 120; // adjust if needed
 
   const tableData = orders.map((order) => {
     const orderNumber = normalizeOneLine(order.orderNumber);
     const detailsWrapped = doc.splitTextToSize(
       htmlToPlain(order.garmentDetails),
       DETAILS_COL_WIDTH
     );
     return [
       order.id ?? '',
       orderNumber,
       normalizeOneLine(order.clientName),
       normalizeOneLine(order.garmentPO),
       detailsWrapped,
       normalizeOneLine(order.jobType),
     ];
   });
 
   const tableColumns = [
     'ID', 'Order Number', 'Client Name', 'Garment PO', 'Garment Details', 'JobType'
   ];
 
   doc.autoTable({
     head: [tableColumns],
     body: tableData,
     startY: 30,
     theme: 'grid',
     styles: {
       fontSize: 8,
       overflow: 'linebreak',
       cellPadding: 2,
     },
     headStyles: {
       fillColor: [22, 160, 133],
       textColor: 255,
     },
     // Key: widen Order Number and keep others reasonable
     columnStyles: {
       0: { cellWidth: 16 },           // ID
       1: { cellWidth: 30 },           // Order Number (wider to stop vertical wrap)
       2: { cellWidth: 30 },           // Client Name
       3: { cellWidth: 30 },           // Garment PO
       4: { cellWidth: DETAILS_COL_WIDTH }, // Garment Details
       5: { cellWidth: 22 },           // JobType
     },
   });
 
   doc.save(`Completed_orders_${moment().format('YYYY-MM-DD')}.pdf`);
 };

  const [garmentDetails, setGarmentDetails] = useState([]);
const fetchGarmentDetails = async (orderId) => {
  try {
      const response = await axios.get(`${API_URL}/orderGarments`, {
          params: { orderId },
      });
      setGarmentDetails(response.data);
  } catch (error) {
      console.error('Error fetching garment details:', error);
  }
};
  return (
    <div className="container" style={{ marginLeft: 250, paddingTop: 20, marginBottom: 70 }}>
      <h2>Completed Jobs</h2>

      {/* Date Filter Inputs */}
      <div className="row">
        <div className="col-md-3">
          <label>From Date:</label>
          <input
            type="date"
            className="form-control"
            name="fromDate"
            value={fromDate}
            onChange={handleDateChange}
          />
        </div>
        <div className="col-md-3">
          <label>To Date:</label>
          <input
            type="date"
            className="form-control"
            name="toDate"
            value={toDate}
            onChange={handleDateChange}
          />
        </div>
        {/* Download Button */}
      
        <div className="col-md-4">
          <label>Search Orders:</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search orders... 🔍"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="col-md-2">
        <Button variant="primary" onClick={downloadPDF}>
          <BsDownload style={{ marginRight: '5px' }} /> {/* Add download icon */}
          Download
        </Button>
        </div>
        <h4>Total no of Completed Orders : {orders.length}</h4>
      </div>
      
      <table className="table table-striped table-hover">
        <thead className="thead-dark table-header">
          <tr>
            <th scope="col">Order Number</th>
            <th scope="col" className="wide-col">Client Name</th>
            <th scope="col" className="wide-col">Client Phone</th>
            <th scope="col" className="extra-wide-col">Client Gmail</th>
            <th scope="col" className="wide-col">Order Status</th>
            <th scope="col" className="wide-col">Order Method</th>
            <th scope="col" className="wide-col">Job Type</th>
            <th scope="col" className="wide-col">
              Due Date
              <i
                className={`bi bi-sort-${sortByDueDate ? 'down' : 'up'} sort-icon`}
                onClick={toggleSortByDueDate}
              ></i>
            </th>
            
            <th scope="col" className="wide-col">Garment PO</th>
            <th scope="col" className="extra-wide-col">Tracking Number</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order, index) => {
            console.log('Current Order Status:', order.orderStatus); // Debug log
            return (
              <React.Fragment key={order.id ?? order.orderNumber}>
                <tr >
                  <td className="order-cell" onClick={() => handleOrderClick(order.orderNumber,order.id)}>
                     {order.orderNumber}
                  </td>
                  <td>{order.clientName}
                    <>
                    {isAdmin ? (<i 
                          className="bi bi-pencil" 
                          style={{ cursor: 'pointer', marginLeft: '5px' }} 
                          onClick={() => handleOrder(order.id,"clientName")}
                        ></i>) : ''}
                    </>
                  </td>
                  <td>{order.clientPhone}
                    <>
                    {isAdmin ? (<i 
                          className="bi bi-pencil" 
                          style={{ cursor: 'pointer', marginLeft: '5px' }} 
                          onClick={() => handleOrder(order.id,"clientPhone")}
                        ></i>) : ''}
                    </>
                  </td>
                  <td>{order.clientgmail}
                    <>
                    {isAdmin ? (<i 
                          className="bi bi-pencil" 
                          style={{ cursor: 'pointer', marginLeft: '5px' }} 
                          onClick={() => handleOrder(order.id,"clientgmail")}
                        ></i>) : ''}
                    </>
                  </td>
                  <td>
                    {order.orderStatus}
                      
                  </td>


                  <td>{order.orderMethod}</td>
                  <td>{order.jobType}</td>
                  
                  <td>{new Date(order.dueDate).toLocaleDateString('en-US')}
                  
                  </td>
                  
                  

                  <td>{order.garmentPO}
                  <>
                    {isAdmin ? (<i 
                          className="bi bi-pencil" 
                          style={{ cursor: 'pointer', marginLeft: '5px' }} 
                          onClick={() => handleOrder(order.id,"garmentPO")}
                        ></i>) : ''}
                  </>
                  </td>
                  
                  
                  <td>
                {order.trackingLabel ? (
                      <>
                        {order.trackingLabel}
                        <>
                          {isAdmin && (
                            <i
                              className="bi bi-pencil"
                              style={{ cursor: 'pointer', marginLeft: '5px' }}
                              onClick={() => handleOrder(order.id, "trackingLabel")}
                            ></i>
                          )}
                        </>
                        {/* Copy icon */}
                        {/* <i
                          className="bi bi-clipboard"
                          style={{ cursor: 'pointer', marginLeft: '10px' }}
                          onClick={() => {
                            navigator.clipboard.writeText(order.trackingLabel);
                            alert('Copied to clipboard!'); // Optional feedback for the user
                          }}
                        ></i> */}
                      </>
                    ) : (
                      <button
                        className="btn btn-primary"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleOrder(order.id, "trackingLabel")}
                      >
                        Add num
                      </button>
                    )}
                  </td>

                  {/* <td>
                    <Button
                      variant="primary"
                      onClick={() => handleSizeModalShow(order.orderNumber,order.shippingAddress)}
                    >
                      Add Size
                    </Button>
                  </td> */}

                  {isAdmin ? (<td>
                    <i
                      className="bi bi-trash"
                      style={{ cursor: 'pointer', color: 'red' }}
                      onClick={() => deleteOrder(order.id)}
                    ></i>
                  </td>  ): ''}

                </tr>
                <tr>
                  <td colSpan="12">
                    <Collapse in={openOrder === order.orderNumber}>
                      <div>
                      <div>
                                                  <p><strong>Garment Details:</strong></p>
                                                  <Button onClick={() => handleAddGarmentsClick(order)}>Add Garments</Button>
                                                  <div style={{ paddingLeft: '20px' }}>
                                                  <div
                                                                                  dangerouslySetInnerHTML={{
                                                                                    __html: DOMPurify.sanitize(
                                                                                      (order.garmentDetails || "")
                                                                                        .replace(/(\r\n|\n|\r)/g, "<br>")   // every newline → <br>
                                                                                    )
                                                                                  }}
                                                                                />
                                                        {
                                                            garmentDetails.length > 0 ? (
                                                              <div style={{ maxWidth: '800px', border: '1px solid #dee2e6', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                                                                <table className="table table-hover" style={{ margin: 0 }}>
                                                                    <thead style={{ background: 'linear-gradient(to right, #333, #555)', color: 'white', textAlign: 'center' }}>
                                                                        <tr>
                                                                            <th style={{ padding: '10px', fontWeight: 'bold' }}>Style</th>
                                                                            <th style={{ padding: '10px', fontWeight: 'bold' }}>PO</th>
                                                                            <th style={{ padding: '10px', fontWeight: 'bold' }}>Description</th>
                                                                            <th style={{ padding: '10px', fontWeight: 'bold' }}>Color</th>
                                                                            <th style={{ padding: '10px', fontWeight: 'bold' }}>Size</th>
                                                                            <th style={{ padding: '10px', fontWeight: 'bold' }}>Quantity</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {garmentDetails.map((detail, index) => (
                                                                            <tr
                                                                                key={index}
                                                                                style={{
                                                                                    backgroundColor: index % 2 === 0 ? '#f8f9fa' : '#ffffff',
                                                                                    transition: 'background-color 0.3s ease',
                                                                                }}
                                                                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e9ecef')}
                                                                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#f8f9fa' : '#ffffff')}
                                                                            >
                                                                                <td style={{ padding: '8px', textAlign: 'center', width: '10%' }}>{detail.style}</td>
                                                                                <td style={{ padding: '8px', textAlign: 'center', width: '10%' }}>{detail.po}</td>
                                                                                <td style={{ padding: '8px', width: '40%' }}>{detail.description}</td>
                                                                                <td style={{ padding: '8px', textAlign: 'center', width: '15%' }}>{detail.color}</td>
                                                                                <td style={{ padding: '8px', textAlign: 'center', width: '10%' }}>{detail.size}</td>
                                                                                <td style={{ padding: '8px', textAlign: 'center', width: '10%' }}>{detail.quantity}</td>
                                                                                {isAdmin && (
                                                                                    <td style={{ padding: '8px', textAlign: 'center', width: '10%' }}>
                                                                                    <button
                                                                                        style={{
                                                                                            backgroundColor: '#dc3545',
                                                                                            color: 'white',
                                                                                            border: 'none',
                                                                                            borderRadius: '5px',
                                                                                            padding: '5px 10px',
                                                                                            cursor: 'pointer',
                                                                                        }}
                                                                                        onClick={() => handleDeleteGarment(detail)}
                                                                                    >
                                                                                        Delete
                                                                                    </button>
                                                                                </td>
                                                                                )}
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                      
                                                          
                                                            ) : (
                                                              <></>
                                                            )
                                                        }
                                                    </div>
                      
                      
                                                  {isAdmin && (
                                                    <i
                                                      className="bi bi-pencil"
                                                      style={{ cursor: 'pointer', marginLeft: '5px' }}
                                                      onClick={() => handleOrder(order.id, "garmentDetails")}
                                                    ></i>
                                                  )}
                                                </div>
                          <p><strong>Notes:</strong> 
                          <div style={{ paddingLeft: '20px' }}>
                              {order.notes ? (
                                <div
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(order.notes || "<p>No notes</p>")
                                }}
                              />
                              ) : (
                                <p>No notes</p>
                              )}
                          </div>
                        <i 
                          className="bi bi-pencil" 
                          style={{ cursor: 'pointer', marginLeft: '5px' }} 
                          onClick={() => handleOrder(order.id,"notes")}
                        ></i>
                        </p>
                        <p><strong>Team:</strong> {order.team}</p>
                        
                        
                        <p><strong>Shipping Address:</strong> {order.shippingAddress}
                        <>
                          {isAdmin ? (<i 
                                className="bi bi-pencil" 
                                style={{ cursor: 'pointer', marginLeft: '5px' }} 
                                onClick={() => handleOrder(order.id,"shippingAddress")}
                              ></i>) : ''}
                        </>
                        </p>
                        
                        

                         
                        
                       
                        <p><strong>Files Uploaded:</strong></p>
                        <ul style={{ display: 'flex', flexWrap: 'wrap', listStyleType: 'none', padding: 0 }}>
                              {order.files && order.files.length > 0 ? (
                                order.files.filter((file) => file.fileUrl)
                                .map((file, idx) => {
                                  const fileUrl = String(file.fileUrl); // Convert fileUrl to a string
                                  const fileName = cleanFileName(fileUrl); // Clean the filename for display

                                  return (
                                    <li key={idx} style={{
                                      margin: '5px',
                                      width: 'calc(100% / 7 - 10px)', 
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}>
                                      {/* Display different content based on file type */}
                                      {fileUrl.match(/\.(jpeg|jpg|gif|png)$/i) ? (
                                        <>
                                          <img
                                            src={fileUrl}
                                            alt={`file-${idx}`}
                                            style={{ width: '100%', height: 'auto', maxWidth: '100px', marginBottom: '5px' }}
                                            onClick={() => handleImageClick(fileUrl)}
                                          />
                                          <div>
                                            <a href={fileUrl} download={fileName}>
                                              {fileName} {/* Display the cleaned filename */}
                                            </a>
                                            
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div style={{
                                              display: 'flex', 
                                              alignItems: 'center', 
                                              justifyContent: 'center', 
                                              width: '100px', 
                                              height: '100px', 
                                              border: '1px solid #ddd', 
                                              borderRadius: '5px', 
                                              backgroundColor: '#f8f9fa'
                                            }}
                                          >
                                            <i className="bi bi-file-earmark-text" style={{ fontSize: '24px' }}></i>
                                          </div>
                                          <div>
                                            <a href={fileUrl} download={fileName}>
                                              {fileName} {/* Display the cleaned filename */}
                                            </a>
                                            
                                          </div>
                                        </>
                                      )}
                                    </li>
                                  );
                                })
                              ) : (
                                <li style={{ width: '100%', textAlign: 'center' }}>No files uploaded.</li>
                              )}
                            </ul>

                      

                      </div>
                    </Collapse>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
          
          
        </tbody>
        {loading && (
          <div className="text-center my-2">
            <Spinner animation="border" role="status" size="sm" />
            <span className="visually-hidden">Loading...</span>
          </div>
        )}

        {/* Sentinel element to observe for infinite scroll trigger */}
        <div ref={sentinelRef} style={{ height: 1 }} />

        
      </table>

      
      <Modal show={showModal3} onHide={() => setShowModal3(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Enter {field}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>{field}</Form.Label>
            {/* Render textarea for notes or garmentDetails, otherwise render input */}
            {field === 'notes' || field === 'garmentDetails' ? (
              <ReactQuill
              theme="snow"
              value={updatedOrder || ""}
              onChange={setUpdatedOrder}
              modules={{
                toolbar: [
                  [{ header: [1, 2, 3, false] }],
                  ["bold", "italic", "underline", "strike"],
                  [{ color: [] }, { background: [] }],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["clean"],
                ],
              }}
              style={{ height: 200 }}
            />
              
            ) : (
              <Form.Control
                type="text"
                value={updatedOrder}
                onChange={(e) => setUpdatedOrder(e.target.value)}
              />
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal3(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => handleUpdateOrder()}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>


      
      {/* Modal for displaying enlarged image */}
      <Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={selectedImage} alt="Enlarged" style={{ width: '100%', height: 'auto' }} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImageModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Size Entry Modal */}
        <Modal show={showSizeModal} onHide={() => setShowSizeModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add Sizes for Order #{selectedOrder}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {/* Category Dropdown */}
              <Form.Group controlId="formCategory">
                <Form.Label>Category</Form.Label>
                <Form.Control
                  as="select"
                  name="category"
                  value={sizeData.category}
                  onChange={handleSizeInputChange}
                >
                  <option value="Adult">Adult</option>
                  <option value="Youth">Youth</option>
                  <option value="Ladies">Ladies</option>
                </Form.Control>
              </Form.Group>

              {/* Description */}
              <Form.Group controlId="formDesc">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  type="text"
                  name="description"
                  value={sizeData.description}
                  onChange={handleSizeInputChange}
                  placeholder="Enter description"
                />
              </Form.Group>

              {/* Color */}
              <Form.Group controlId="formColor">
                <Form.Label>Color</Form.Label>
                <Form.Control
                  type="text"
                  name="color"
                  value={sizeData.color}
                  onChange={handleSizeInputChange}
                  placeholder="Enter color"
                />
              </Form.Group>

              {/* Size Inputs */}
              <Form.Group controlId="formSizes">
                <Form.Label>Sizes</Form.Label>

                {/* First Row: XS, S, M, L */}
                <div className="row mb-3">
                  <div className="col-md-3 col-sm-4 col-6 mb-2">
                    <Form.Label>XS</Form.Label>
                    <Form.Control
                      type="number"
                      name="xs"
                      value={sizeData.xs}
                      onChange={handleSizeInputChange}
                      placeholder="XS"
                      min="0"
                    />
                  </div>
                  <div className="col-md-3 col-sm-4 col-6 mb-2">
                    <Form.Label>S</Form.Label>
                    <Form.Control
                      type="number"
                      name="s"
                      value={sizeData.s}
                      onChange={handleSizeInputChange}
                      placeholder="S"
                      min="0"
                    />
                  </div>
                  <div className="col-md-3 col-sm-4 col-6 mb-2">
                    <Form.Label>M</Form.Label>
                    <Form.Control
                      type="number"
                      name="m"
                      value={sizeData.m}
                      onChange={handleSizeInputChange}
                      placeholder="M"
                      min="0"
                    />
                  </div>
                  <div className="col-md-3 col-sm-4 col-6 mb-2">
                    <Form.Label>L</Form.Label>
                    <Form.Control
                      type="number"
                      name="l"
                      value={sizeData.l}
                      onChange={handleSizeInputChange}
                      placeholder="L"
                      min="0"
                    />
                  </div>
                </div>

                {/* Second Row: XL, XXL, XXXL, XXXXL, XXXXXL */}
                <div className="row">
                  <div className="col-md-3 col-sm-4 col-6 mb-2">
                    <Form.Label>XL</Form.Label>
                    <Form.Control
                      type="number"
                      name="xl"
                      value={sizeData.xl}
                      onChange={handleSizeInputChange}
                      placeholder="XL"
                      min="0"
                    />
                  </div>
                  <div className="col-md-3 col-sm-4 col-6 mb-2">
                    <Form.Label>2XL</Form.Label>
                    <Form.Control
                      type="number"
                      name="xxl"
                      value={sizeData.xxl}
                      onChange={handleSizeInputChange}
                      placeholder="XXL"
                      min="0"
                    />
                  </div>
                  <div className="col-md-3 col-sm-4 col-6 mb-2">
                    <Form.Label>3XL</Form.Label>
                    <Form.Control
                      type="number"
                      name="xxxl"
                      value={sizeData.xxxl}
                      onChange={handleSizeInputChange}
                      placeholder="XXXL"
                      min="0"
                    />
                  </div>
                  
                </div>
                <div className='row'>
                  <div className="col-md-3 col-sm-4 col-6 mb-2">
                      <Form.Label>4XL</Form.Label>
                      <Form.Control
                        type="number"
                        name="xxxxl"
                        value={sizeData.xxxxl}
                        onChange={handleSizeInputChange}
                        placeholder="XXXXL"
                        min="0"
                      />
                    </div>
                    <div className="col-md-3 col-sm-4 col-6 mb-2">
                      <Form.Label>5XL</Form.Label>
                      <Form.Control
                        type="number"
                        name="xxxxxl"
                        value={sizeData.xxxxxl}
                        onChange={handleSizeInputChange}
                        placeholder="XXXXXL"
                        min="0"
                      />
                    </div>
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowSizeModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSizeFormSubmit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
            {/* Garment Modal */}
                            <Modal
                          show={showGarmentModal}
                          onHide={() => setShowGarmentModal(false)}
                          centered
                          size="xl" // Enlarges the modal
                      >
                          <Modal.Header closeButton>
                              <Modal.Title>Select Garments</Modal.Title>
                          </Modal.Header>
                          <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
                              <Table striped bordered hover responsive>
                                  <thead className="table-dark">
                                      <tr>
                                          <th>Garment ID</th>
                                          <th>PO</th>
                                          <th>Style</th>
                                          <th>Garment Desc</th>
                                          <th>Color</th>
                                          <th>Size</th>
                                          <th>Available Quantity</th>
                                          <th>Checked In</th>
                                          <th>Assign Quantity</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {garments.map((garment) => (
                                          <tr key={garment.id}>
                                              <td>{garment.id}</td>
                                              <td>{garment.customer_po}</td>
                                              <td>{garment.style}</td>
                                              <td>{garment.description}</td>
                                              <td>{garment.color}</td>
                                              <td>{garment.size}</td>
                                              
                                              <td>{garment.qty}</td>
                                              <td>{garment.verified ? 'YES' :'NO'}</td>
                                              <td>
                                                  <Form.Control
                                                      type="number"
                                                      min="1"
                                                      max={garment.qty}
                                                      onChange={(e) =>
                                                        handleSelectGarment(
                                                            garment.id,
                                                            garment.customer_po,
                                                            garment.style,
                                                            garment.description,
                                                            garment.color,
                                                            garment.size,
                                                            garment.qty,                                                
                                                            parseInt(e.target.value, 10)
                                                        )
                                                    }
                                                      style={{
                                                          width: '100%',
                                                          padding: '5px 10px',
                                                          borderRadius: '4px',
                                                          border: '1px solid #ced4da',
                                                      }}
                                                  />
                                              </td>
                                          </tr>
                                      ))}
                                  </tbody>
                              </Table>
                          </Modal.Body>
                          <Modal.Footer>
                              <Button variant="secondary" 
                              onClick={() => setShowGarmentModal(false)}
                              >
                                  Cancel
                              </Button>
                              <Button variant="primary"
                               onClick={handleAssignGarments}
                               >
                                  Assign Garments
                              </Button>
                          </Modal.Footer>
                      </Modal>

    </div>
  );
};

export default Completed;
